import { FormConfigResponse } from './types/form';
import { ApiFactoryClassType } from './factory';

const form = (factory: ApiFactoryClassType) => ({
    getConfig: async (
        type: string,
        id: string | null = null,
    ): Promise<FormConfigResponse | null> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(
                    `/api/form/${type}${id ? `/${id}` : ''}`,
                    factory.getApiHost(),
                ),
                {
                    method: 'GET',
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                        'Accept-Language': factory.getRequestLocale(),
                    },
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            if (response.status >= 400) {
                return null;
            }

            return response.json();
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
});

export default form;
